import React, { lazy } from 'react';

const Login = lazy(() => import('../pages/Authentication/Login'));
const AutoLogin = lazy(() => import('../pages/Authentication/AutoLogin'));
const ForgotPassword = lazy(() => import('../pages/Authentication/ForgotPassword'));
const ResetPassword = lazy(() => import('../pages/Authentication/ResetPassword'));
const OtpScreen = lazy(() => import('../pages/Authentication/OtpScreen'));
const Employers = lazy(() => import('../pages/Employers'));
const AddEmployer = lazy(() => import('../pages/Employers/AddEmployer.jsx'))
const NotFound = lazy(() => import('../pages/Errors/NotFound'));
const MyEmployers = lazy(() => import('../pages/MyEmployers/index.jsx'));
const CreateEmployee = lazy(() => import('../pages/MyEmployers/CreateEmployee.jsx'));
const BulkUpload = lazy(() => import('../pages/MyEmployers/BulkUpload.js'));
const Home = lazy(() => import('../pages/Home'));
const Help = lazy(() => import('../pages/Help/Help'));
const PlanOverview = lazy(() => import('../pages/plan-overview/PlanOverview'));
const EmployerInfo = lazy(() => import('../pages/EmployerInfo/EmployerInfo'));
const Analytics = lazy(() => import('../pages/Analytics/Analytics'));

const publicRoutes = [
    { path: "/login", element: <Login />, name: 'login' },
    { path: "/forget-password", element: <ForgotPassword />, name: 'forget-password' },
    { path: "/reset-password/:id", element: <ResetPassword />, name: 'reset-password' },
    { path: "/otp/:id", element: <OtpScreen />, name: 'otp' },
    { path: "autologgedin/:id", element: <AutoLogin />, name: 'autologgedin' },
    {
        path: "*",
        exact: true,
        element: <NotFound />,
    }
]

const autoLoggedInRoutes = [
    { path: "/employer", element: <Employers />, name: 'employer' },
    {
        path: "*",
        exact: true,
        element: <NotFound />,
    }
]

const authProtectedRoutes = [
    { path: "/home", element: <Home />, name: 'home' },
    { path: "/plan-overview", element: <PlanOverview />, name: 'plan-overview' },
    { path: "/analytics", element: <Analytics />, name: 'analytics' },
    { path: "/employer", element: <Employers />, name: 'employer' },
    { path: "/employer/create", element: <AddEmployer />, name: 'employer' },
    { path: "/employer/view/:id", element: <AddEmployer />, name: 'employer' },
    { path: "/employer-details", element: <EmployerInfo />, name: 'employer-details' },
    { path: "/my-employers", element: <MyEmployers /> },
    { path: "/my-employers/add", element: <CreateEmployee />, name: 'create-employee-data' },
    { path: "/my-employers/edit/:id", element: <CreateEmployee />, name: 'edit-employee-data' },
    { path: "/my-employers/view/:id", element: <CreateEmployee />, name: 'view-employee-data' },
    { path: "/my-employers/upload", element: <BulkUpload /> },
    { path: "/help", element: <Help />, name: 'help' },
    {
        path: "*",
        exact: true,
        element: <NotFound />
    }
];

const allRoutes = [...authProtectedRoutes, ...publicRoutes, ...autoLoggedInRoutes];

const isValidRoute = (path) => {
    return allRoutes.some(route => route.path === path);
};


export { authProtectedRoutes, publicRoutes, autoLoggedInRoutes, isValidRoute };